import Wrapper from "../../../layout/Wrapper";
import CaseStatementContractServiceComponent from "../../../screens/contractControll/caseIdiomsContract";

import MetaComponent from "../../../components/common/MetaComponent";
import { t } from "i18next";

const metadata = {
	title: t('menu.contractControl.caseStatement'),
	description: "",
};

export default function AgentService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CaseStatementContractServiceComponent />
		</Wrapper>
	);
}